import type { ReactNode } from "react";
import { cn } from "../../../lib/utils";
import { Typography } from "../Typography";

type TStatusPageProps = {
  gradientAccent?: string;
  icon: ReactNode;
  title: string;
  description: string;
  actions: ReactNode;
};

export const StatusPage = ({ gradientAccent, icon, title, description, actions }: TStatusPageProps) => {
  return (
    <div
      className={cn(
        "flex min-h-[calc(100vh-var(--navbar-height))] items-center justify-center overflow-hidden bg-gradient-to-br from-background to-background px-4 py-8",
        gradientAccent,
      )}
    >
      <div className="flex w-full max-w-md flex-col items-center gap-8 text-center">
        {icon}

        <div className="space-y-3">
          <Typography className="text-4xl font-bold text-foreground md:text-5xl">{title}</Typography>
          <Typography variant="p" className="mx-auto max-w-sm text-base leading-relaxed text-muted-foreground md:text-lg">
            {description}
          </Typography>
        </div>

        <div className="w-full max-w-xs space-y-3">{actions}</div>
      </div>
    </div>
  );
};
